import { render, staticRenderFns } from "./faqMain.vue?vue&type=template&id=1add6a3a&scoped=true"
import script from "./faqMain.vue?vue&type=script&lang=js"
export * from "./faqMain.vue?vue&type=script&lang=js"
import style0 from "./faqMain.vue?vue&type=style&index=0&id=1add6a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1add6a3a",
  null
  
)

export default component.exports